import { Card, FormattedMessageDiv } from '@odmonorepo/core-components';
import { Col, Row, Stack } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

interface PartnerNameCardProps {
  partnerName?: string;
}

// Hidden entirely when there is no partner name available (e.g. non-ISO applications).
export const PartnerNameCard = ({ partnerName }: PartnerNameCardProps) => {
  if (!partnerName) return null;

  return (
    <Card className="bg-light-gray shadow-none" bodyClassName="p-md-5 px-md-6 p-4">
      <Stack gap={3}>
        <FormattedMessageDiv className="fw-bold text-start" id="offerReview.offerProvider" />
        <Row className="text-start g-0 align-items-center flex-nowrap">
          <Col xs="auto" className="text-nowrap">
            <FormattedMessage id="offerReview.offerProvider.onDeckPartner" />
          </Col>
          {/* minWidth: 0 lets this column shrink below its content's natural width instead of forcing the row to wrap. */}
          <Col className="text-end fw-500" style={{ minWidth: 0 }}>
            {partnerName}
          </Col>
        </Row>
      </Stack>
    </Card>
  );
};

export default PartnerNameCard;
